import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit } from '@angular/core';
import { CommentModelComingFrom, InspectionObservationPointsViewModel, PreInspectionChecklistVM } from '../../../../inspection.model';
import { MatDialog } from '@angular/material/dialog';import { CommentPopupComponent } from './comment-popup/comment-popup.component';

@Component({
  selector: 'observation-comments',
  templateUrl: './observation-comments.component.html',
  styleUrls: ['./observation-comments.component.scss']
})
export class ObservationCommentsComponent implements OnInit, AfterViewInit {
@Input() IspreChecklist:boolean=false;
@Input() preChecklist:PreInspectionChecklistVM

  @Input()
  comment = '';
  @Input()
  observationPoint: InspectionObservationPointsViewModel;
  @Input()
  comingFrom: CommentModelComingFrom;
  @Output()
  onCommentChange: EventEmitter<any> = new EventEmitter();

  constructor(

    private _dialog: MatDialog,
    ) { }

  ngOnInit() {
    if (this.comingFrom !== undefined) {
      switch (this.comingFrom) {
        case CommentModelComingFrom.Interpretation:
          if (this.observationPoint !== undefined) {
            this.comment = this.observationPoint.Comments;
          }
        break;
        case CommentModelComingFrom.PreChecklist:
          if (this.preChecklist !== undefined) {
            this.comment = this.preChecklist.Comment;
          }
        break;
        default:
        break;
      }
    }
  }

 ngAfterViewInit(): void {

  }

  viewComment() {
    const passingData = {
            comingFrom: this.comingFrom,
            comment: this.IspreChecklist==false?this.observationPoint.Comments:this.preChecklist.Comment ,
            observation: this.observationPoint,
            checklist:this.preChecklist

    };

    const viewCommentModalRef = this._dialog.open(CommentPopupComponent, {
      width: '1032px',
      data: passingData,
    });
    viewCommentModalRef.afterClosed().subscribe(reloadComment => {
      if (reloadComment) {

        this.comment = reloadComment;
        if(this.IspreChecklist==false)
        this.observationPoint.Comments = reloadComment;
        else
        this.preChecklist.Comment=reloadComment;
        this.onCommentChange.emit(reloadComment);
      }
    });
  }

}
